import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';

export class RavelLed extends RavelElement {
    static get localStyles() {
        return `
        <style>
            #container {
                position: absolute;
                border-radius: 50%;
            }
            #led-glow {
                position: absolute;
                border-radius: 50%;
                top: 25%;
                left: 25%;
                width: 50%;
                height: 50%;
            }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container">
        <div id="led-img"></div>
        <div id="led-glow"></div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 
            'message-id', 'color', 'glow', 
            'state', 'size', 'x', 'y',  'inline', 'signals' ]; 
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#container');
        this.ledId = 0;
        this.size = 50;
        this.states = 2;
        this.state = 0;
        this.stateDir = 1;
        this.inline = false;
        this.glowColor = '#ffffff';
        this.signals = [];
    }
  
    setup = () => {
        this.observedMessages = [`${this.messageId}`];
        // Send 'toggle', 'on-for-ms', 'blink-on', 'blink-off'
        this.subscribe(this.observedMessages);
        this.glow = this.shadowRoot.querySelector('#led-glow');
        this.container.style.left =  `${this.x}px`;
        this.container.style.top =  `${this.y}px`;
        if (this.inline) {
            this.container.style.display = 'block';
        }
        this.shadowRoot.querySelector('#led-img').innerHTML = this.ledSvg;
        this.shadowRoot.querySelector('#led-background').style.fill = this.color;
        this.shadowRoot.querySelector('#led').style.width = `${this.size}px`;
        this.shadowRoot.querySelector('#led').style.height = `${this.size}px`;
        this.msTimer = null;
        this.blinkTimer = null;
        this.addEventListener(`${this.messageId}`, this.handleMessages);
    }
    
    handleMessages = (evt) => {
        if (evt.detail.cmd === 'on-for-ms') {
            let ms = Number(evt.detail.content);
            this.glow.style.boxShadow = `0px 0px ${this.size / 2}px ${this.size / 2}px ${this.glowColor}`;
            this.msTimer = setTimeout(() => {
                this.glow.style.boxShadow = 'none';
            }, ms);
        }
    }

    teardown = () => {
        this.unsubscribe(this.observedMessages);
    }
    
    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);

        if (name === 'message-id') {
            this.messageId = newValue;
        }
        if (name === 'size') {
            this.size = Number(newValue);
        }
        if (name === 'x') {
            this.x = newValue;
        }
        if (name === 'y') {
            this.y = newValue;
        }
        if (name === 'orientation') {
            this.orientation = newValue;
        }
        if (name === 'led-id') {
            this.ledId = newValue;
        }
        if (name === 'color') {
            this.color = newValue;
        }
        if (name === 'inline') {
            this.inline = true;
        }
        if (name === 'state') {
            this.state = newValue;
        }
        if (name === 'blink-rate') {
            this.blinkRate = newValue;
        }
        if (name === 'states') {
            this.states = parseInt(newValue, 10);
        }
        if (name === 'glow') {
            this.glowColor = newValue;
        }
        if (name === 'signals') {
            this.signals = newValue.split(',');
        }
    }

    ledSvg = `
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   width="19.742495mm"
   height="19.741852mm"
   viewBox="0 0 19.742495 19.741852"
   version="1.1"
   id="led"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <sodipodi:namedview
     id="namedview1"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:document-units="mm" />
  <defs
     id="defs1" />
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-16.247012,-38.049292)">
    <path
       id="path-1"
       style="opacity:1;fill:#000000;stroke:none;stroke-width:1.64789;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
       d="m 21.121161,38.049293 v 2.277435 h -2.547148 v 2.596716 h -2.327001 v 9.993552 h 2.327001 v 2.59607 h 2.547148 v 2.278079 h 9.993552 v -2.278079 h 2.547793 v -2.59607 h 2.327001 v -9.993552 h -2.327001 v -2.596716 h -2.547793 v -2.277435 z"
       inkscape:export-filename="led.svg"
       inkscape:export-xdpi="96"
       inkscape:export-ydpi="96" />
    <circle
       style="fill:#00cc00;stroke:none;stroke-width:0.393338;stroke-linecap:round;stroke-linejoin:round"
       id="led-background"
       cx="26.118259"
       cy="47.920219"
       r="6.6145835" />
    <path
       id="rect3"
       style="opacity:0.488889;fill:#000000;stroke:none;stroke-width:1.32292;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none"
       d="m 19.955888,50.278068 a 6.6145835,6.6145835 0 0 0 6.162414,4.256588 6.6145835,6.6145835 0 0 0 6.161898,-4.256588 z"
       inkscape:export-filename="led.svg"
       inkscape:export-xdpi="96"
       inkscape:export-ydpi="96" />
  </g>
</svg>

`;
}
